export default {
  ll: {
    actions: 'Actions',
    all: 'All',
    allFilters: 'All Filters',
    apply: 'Apply',
    areYouSure: 'Are you sure?',
    cancel: 'Cancel',
    carousel: {
      imageLabel: 'Image {index} of {total}',
      paginationLabel: 'Go to image {index}',
    },
    clear: 'Clear',
    closeModal: 'Close modal',
    confirm: 'Confirm',
    copy: {
      copied: 'Copied!',
      copyToClipboard: 'Copy to clipboard',
    },
    datePicker: {
      dateFormat: 'Date format',
      today: 'Today',
    },
    pageStats: '{from} - {to} of {total}',
    emptyState: {
      noResults: 'No results',
    },
    fileUpload: {
      dragDropFileHere: 'Drag and drop your file here',
      errors: {
        incorrectFileType: 'Please drop a file with type: {fileTypes}',
      },
      or: 'or',
      remove: 'Remove',
      uploadFile: 'Upload File',
    },
    filter: 'Filter',
    filterBy: 'Filter by',
    filters: 'Filters',
    httpError: {
      401: {
        title: 'Unauthorized',
        description: 'Sorry, you are not authorized to access the LeafLink portal!',
      },
      403: {
        title: 'Access denied.',
        description: `Sorry, you can not access the page you are looking for. Talk to your account admin regarding your account's permission settings.`,
      },
      404: {
        title: `Sorry, we can't find this page.`,
        description: `We couldn't find the page you're looking for.`,
      },
      405: {
        title: 'Not allowed.',
        description: `We couldn't reach the page you're looking for this way.`,
      },
      '50X': {
        title: 'Please wait while we hash this out.',
        description: `You've encountered an error.`,
      },
      504: {
        title: 'Your request got lost in the weeds.',
        description: `You've encountered an error.`,
      },
    },
    listView: {
      calculating: 'Calculating results...',
      clearSelection: 'Clear Selection',
      deselectAllCount: 'Deselect all ({count})',
      numItemsSelected: '{totalSelectedCount} of {totalCount} items selected',
      numberOfTotalSelected: '{num} of {total} selected',
      selectAll: 'Select all',
      selectAllCount: 'Select all ({count})',
      sortBy: 'Sort by',
      totalResults: 'Showing {num} of {total} results',
    },
    many: 'Many',
    numberOfActiveFilters: 'Number of active filters',
    okay: 'Okay',
    optional: 'optional',
    pageNavigation: {
      more: 'More',
    },
    more: 'More',
    next: 'Next',
    previous: 'Previous',
    reset: 'Reset',
    resetAll: 'Reset all',
    search: 'Search',
    select: {
      self: 'Select',
      empty: 'No options',
      placeholder: 'Select option',
      selected: 'selected',
    },
    selectAll: 'Select all',
    sort: 'Sort',
    stepper: {
      currentStep: 'Step {num} of {total}',
    },
    table: {
      collapseRow: 'Collapse row',
      expandRow: 'Expand row',
    },
    validation: {
      email: 'Email must be valid',
      maxLength: 'Must be at most {max} characters',
      maxValue: 'Must be at most {max}',
      minLength: 'Must be at least {min} characters',
      minValue: 'Must be at least {min}',
      positiveNumber: 'Must be greater than 0',
      price: 'Must have 2 decimal places',
      required: 'Required',
      wholeNumber: 'Must be a Whole Number',
    },
    viewFilterGroup: 'View filter group',
    thumbnail: {
      altText: 'Image {index} of {total}',
      removeButton: 'Remove image {index}',
    },
  },
};
